import { type ReactNode, useEffect } from 'react'
import { usePage } from '@inertiajs/react'
import { ThemeProvider } from '@gravity-ui/uikit'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { LocaleSync } from '@/i18n'
import { flushServerEvents, type ServerEvent } from '@/lib/analytics'

// Sends the funnel events the server confirmed on this response (see
// AnalyticsEvents). Renders nothing.
function ServerEvents() {
  const { analytics_events } = usePage<{ analytics_events?: ServerEvent[] }>().props
  useEffect(() => { flushServerEvents(analytics_events) }, [analytics_events])
  return null
}

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme="light">
      <LocaleSync />
      <ServerEvents />
      {/* Full-width, responsive: colored section bands span the whole viewport;
          inner content is centred with a comfortable max-width (no letterbox margins). */}
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#ffffff' }}>
        <Header />
        <main style={{ flex: 1 }}>{children}</main>
        <Footer />
      </div>
    </ThemeProvider>
  )
}
